import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { SocialLinks } from "@/components/SocialLinks";
import { SiteHeader } from "@/components/SiteHeader";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { dateStyle: "long" }) : "");

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined); // undefined=loading, null=not found

  useEffect(() => {
    axios.get(`${API}/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(null));
  }, [slug]);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="blog-post-page">
      <SiteHeader />

      <main className="max-w-3xl mx-auto px-6 py-16 lg:py-24 w-full flex-1">
        {post === undefined && <p className="text-sm text-[#9CA3AF]" data-testid="blog-post-loading">Loading...</p>}
        {post === null && (
          <div data-testid="blog-post-notfound">
            <h1 className="font-head text-3xl font-black">Post not found</h1>
            <p className="text-[#3A4A63] mt-3">This post may have been moved or removed.</p>
            <Link to="/blog" className="inline-block mt-6 bg-[#041C3E] text-white px-6 py-3 text-sm font-semibold hover:bg-[#D94833] transition-colors">
              Back to the blog
            </Link>
          </div>
        )}
        {post && (
          <motion.article
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            data-testid="blog-post-article"
          >
            <p className="text-xs uppercase tracking-[0.15em] text-[#9CA3AF]">{fmt(post.created_at)}</p>
            <h1 data-testid="blog-post-title"
                className="font-head text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight font-black mt-3">
              {post.title}
            </h1>
            <div
              data-testid="blog-post-body"
              className="blog-prose mt-8"
              dangerouslySetInnerHTML={{ __html: post.html }}
            />
          </motion.article>
        )}
      </main>

      <footer className="bg-[#041C3E] text-white py-12">
        <div className="max-w-3xl mx-auto px-6 flex flex-col md:flex-row justify-between gap-6 items-start md:items-center">
          <p className="font-head font-black text-xl">The Next Move<span className="text-[#D94833]"> by Rhellex</span></p>
          <div data-testid="footer-contact" className="md:text-center">
            <p className="text-white text-sm font-semibold">Contact Rhea</p>
            <a href="mailto:thenextmovebyrhellex@gmail.com" className="text-white/60 text-sm hover:text-white transition-colors">thenextmovebyrhellex@gmail.com</a>
          </div>
          <SocialLinks tone="dark" />
        </div>
      </footer>
    </div>
  );
}
